import { modulesList } from '@/components/printModules';

/** 产品标签二维码固定走产品管理 modules，扫码才进产品 */
export const LABEL_QRCODE_MODULES = 66;

function isValidId(value) {
  return value !== null && value !== undefined && value !== '' && typeof value !== 'boolean';
}

function resolveField(row, field) {
  if (!row || !field) return null;
  if (isValidId(row[field])) return row[field];
  const foundKey = Object.keys(row).find((key) => {
    return (key.includes(field) || field.includes(key)) && isValidId(row[key]);
  });
  return foundKey ? row[foundKey] : null;
}

function pickQty(row) {
  const keys = [
    'baseEntranceHomeAmount',
    'baseOutsourcingFinishedQuantity',
    'valueMaterialQuantity',
    'baseAmount',
    'baseQuantity',
    'valueInwarehouseQuantity',
    'valueLockInwarehouseQuantity',
    'valueReceiptAmount',
    'baseOutsourcingQuantity'
  ];
  for (let i = 0; i < keys.length; i++) {
    const n = Number(row && row[keys[i]]);
    if (Number.isFinite(n) && n > 0) return n;
  }
  return 1;
}

export function lastTemplateStorageKey(modules, printMode) {
  return (
    'printLastTemplate:' +
    String(modules == null ? '' : modules) +
    ':' +
    String(printMode || 'normal')
  );
}

export function resolvePreferredLabelTemplate(list, modules) {
  const visible = Array.isArray(list) ? list : [];
  if (!visible.length) return null;
  if (modules != null && typeof localStorage !== 'undefined') {
    try {
      const raw = localStorage.getItem(lastTemplateStorageKey(modules, 'normal'));
      if (raw) {
        const lastId = JSON.parse(raw);
        const hit = visible.find((item) => String(item.sysPrintId) === String(lastId));
        if (hit) return hit;
      }
    } catch (e) {
      /* ignore */
    }
  }
  return visible.find((item) => item && item.isDefault == 0) || visible[0] || null;
}

export function normalizeLabelProductRow(row, modules) {
  const item = Object.assign({}, row);
  item.materialId =
    item.materialId || item.baseMaterialId || item.baseMetaMaterialId || item.baseMetaMaterialid;
  item.specGroupId =
    item.specGroupId ||
    item.baseSpecGroupId ||
    item.baseMetaSpecgroupId ||
    item.baseSpecgroupId ||
    item.baseMaterialSpecgroupId;
  item.baseAmount = pickQty(item);
  item.baseQuantity = item.baseQuantity || item.baseAmount;
  if (item.materialId) {
    const qr = { modules: LABEL_QRCODE_MODULES, productId: String(item.materialId) };
    if (item.specGroupId) qr.specGroupId = item.specGroupId;
    item.qrcode = JSON.stringify(qr);
  }
  return item;
}

function extractDetailRows(doc) {
  if (!doc || typeof doc !== 'object') return [];
  const preferred = [
    'purchasesReceiptDocDetailList',
    'outsourcingtowarehouseDetailList',
    'outsourcingToWarehouseDetailList',
    'processCoopDeliveryDetailList',
    'processCoopDeliveryDocDetailList'
  ];
  for (let i = 0; i < preferred.length; i++) {
    const list = doc[preferred[i]];
    if (Array.isArray(list) && list.length) {
      return mergeHeaderRows(doc, list);
    }
  }
  const lists = [];
  Object.keys(doc).forEach((key) => {
    if (/DetailList$/i.test(key) && Array.isArray(doc[key]) && doc[key].length) {
      lists.push(doc[key]);
    }
  });
  if (lists.length) {
    return mergeHeaderRows(doc, lists[0]);
  }
  return [doc];
}

function mergeHeaderRows(doc, list) {
  const header = {};
  Object.keys(doc).forEach((key) => {
    const val = doc[key];
    if (val !== null && typeof val !== 'object') header[key] = val;
  });
  return list.map((row) => Object.assign({}, header, row));
}

function isProductRow(item) {
  return !!(
    item &&
    (item.materialId || item.baseMaterialNumber || item.baseMaterialName)
  );
}

export async function fetchLabelPrintRows({ changeList, printFun, modules }) {
  const rows = changeList || [];
  if (!rows.length) return [];
  if (!printFun) {
    return rows.map((row) => normalizeLabelProductRow(row, modules)).filter(isProductRow);
  }

  const moduleConfig = modulesList[String(modules)] || {};
  const keys = moduleConfig.key || [];
  const values = moduleConfig.value || keys;
  const seen = new Set();
  const out = [];

  for (let i = 0; i < rows.length; i++) {
    const row = rows[i];
    const form = {};
    keys.forEach((key, idx) => {
      form[key] = resolveField(row, values[idx] || key);
    });
    let datakey = null;
    let datavalue = null;
    Object.keys(form).forEach((fk) => {
      if (isValidId(form[fk])) {
        datakey = fk;
        datavalue = form[fk];
      }
    });
    if (!isValidId(datavalue)) {
      const fallback = normalizeLabelProductRow(row, modules);
      if (isProductRow(fallback)) out.push(fallback);
      continue;
    }
    const dedupe = String(datakey) + ':' + String(datavalue);
    if (seen.has(dedupe)) continue;
    seen.add(dedupe);
    try {
      const res = await printFun({ [datakey]: datavalue });
      const data = (res && res.data && res.data.data) || {};
      extractDetailRows(data).forEach((item) => {
        const mapped = normalizeLabelProductRow(item, modules);
        if (isProductRow(mapped)) out.push(mapped);
      });
    } catch (e) {
      const fallback = normalizeLabelProductRow(row, modules);
      if (isProductRow(fallback)) out.push(fallback);
    }
  }
  return out;
}
